import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import { encode } from 'qss'; // See available options here
// https://github.com/acast-tech/image-api#formatting-images

export default function getImageUrl(src, imageCdnUrl, options) {
  var imgSource = src && src.original ? src.original : src;

  if (!imgSource || typeof imgSource !== 'string') {
    return undefined;
  }

  if (!imageCdnUrl) {
    return imgSource;
  } // If the link already contains the cdn url we don't need to do anything


  if (imgSource.indexOf(imageCdnUrl) !== -1) {
    var imgSourceWithoutQuery = imgSource.split('?')[0];

    var _query = encode(options);

    return imgSourceWithoutQuery + (_query ? "?".concat(_query) : '');
  } // Our image scaler can't handle gravatar.com image so for now we let them bypass the scaler


  if (imgSource.indexOf('gravatar.com') !== -1) {
    return imgSource;
  }

  var query = encode(options);
  return "".concat(imageCdnUrl, "/image?source=").concat(imgSource).concat(query ? "&".concat(query) : '');
}